// extracted by mini-css-extract-plugin
module.exports = {"root":"Button_root__MAi56","cancel":"Button_cancel__3qMY0","submit":"Button_submit__1DEyv"};